module.exports = __webpack_public_path__ + "static/media/dance.a8b204c6.webm";